// Seeded RNG (mulberry32). Deterministic runs make balance testing reproducible.
export class Rand {
  constructor(seed = Date.now() >>> 0) { this.seed = seed >>> 0; this.s = this.seed; }

  reseed(seed) { this.seed = seed >>> 0; this.s = this.seed; }

  next() {
    let t = (this.s += 0x6D2B79F5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  range(a, b) { return a + this.next() * (b - a); }
  int(a, b) { return Math.floor(this.range(a, b + 1)); }
  pick(arr) { return arr[Math.floor(this.next() * arr.length)]; }
  chance(p) { return this.next() < p; }

  // Uniform point on unit sphere.
  onSphere(out) {
    const u = this.next() * 2 - 1, th = this.next() * Math.PI * 2;
    const r = Math.sqrt(1 - u * u);
    out.set(r * Math.cos(th), u, r * Math.sin(th));
    return out;
  }

  shuffle(arr) {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(this.next() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }
}

export const rand = new Rand();
